import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../../software-dynamic-version-2/mainSection-multiple-inputs-v-2';
import IrtizaDynamicInputGrid from '../../software-dynamic-version-2/popup-input-grid-v-2';


const AccessoryOpeningAdd = (props) => {
  
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};
  
  const [inputProps, setInputProps] = useState({
  
    // AccessoryOpeningID	OpeningType	OpeningDate	GodownID	Remarks

    AccessoryOpeningID:{name: 'AccessoryOpeningID',   value: props.AccessoryOpeningID || '0' },
    OpeningType:{name: 'OpeningType',   value: 'Stock At Factory' },
    OpeningDate:{name: 'OpeningDate',   value: 'currentDate' },

    GodownName:{
      name:{id:'GodownID',value:'GodownName'},
      caption: 'Select Godown',
      value: {id: props.GodownID || 2 ,value:props.GodownName || ''},
      dataSource: {type:'Route',route:'GodownInfo'},
        },


        Remarks:{name: 'Remarks',   value: props.Remarks || '-' },


        });
// EXTRA CODE START

// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
  
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };

  // AccessoryOpeningID	OpeningType	OpeningDate	GodownID	Remarks

  let inputsList = [
    {Input: HiddenComponent ,Props: {...inputProps.AccessoryOpeningID, setInputProps },ColumnSize:0},
    {Input: HiddenComponent ,Props: {...inputProps.OpeningType, setInputProps },ColumnSize:0},
    {Input: DateComponent,Props: {...inputProps.OpeningDate, setInputProps },ColumnSize:3},
    {Input: DropdownComponent,Props: {...inputProps.GodownName, setInputProps },ColumnSize:6},
    {Input: TextComponent,Props: {...inputProps.Remarks,setInputProps },ColumnSize:12},
    ];
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`Accessory Opening ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      </div>
  );
}; 

export default AccessoryOpeningAdd;
